import { useEffect } from "react"

export default function useAgendaSyncController({
  clinicId,
  date,
  patientQuery,
  showNewModal,
  newAppt,
  patients,
  calendarRef,
  lastCalendarDateRef,
  setPatients,
  setTreatments,
  setDoctors,
  setHeldSlots,
  setEvents,
  loadPatients,
  loadTreatments,
  loadDoctors,
  loadHeldSlots,
  loadAgenda
}) {
  useEffect(() => {
    if (!showNewModal || !newAppt.patientId || clinicId === "ALL" || !clinicId) return

    const exists = patients.some((p) => String(p.id) === String(newAppt.patientId))
    if (exists) return

    loadPatients(clinicId, "")
  }, [
    showNewModal,
    newAppt.patientId,
    clinicId,
    patients,
    loadPatients
  ])

  useEffect(() => {
    if (!clinicId) {
      setPatients([])
      setTreatments([])
      setDoctors([])
      setHeldSlots([])
      setEvents([])
      return
    }

    const run = async () => {
      await loadPatients(clinicId, "")
      await loadTreatments(clinicId)
      await loadDoctors(clinicId)
      await loadHeldSlots(clinicId, date)
    }

    run()
  }, [
    clinicId,
    date,
    setPatients,
    setTreatments,
    setDoctors,
    setHeldSlots,
    setEvents,
    loadPatients,
    loadTreatments,
    loadDoctors,
    loadHeldSlots
  ])

  useEffect(() => {
    if (!clinicId || clinicId === "ALL") return

    const timeout = setTimeout(() => {
      loadPatients(clinicId, patientQuery)
    }, 250)

    return () => clearTimeout(timeout)
  }, [patientQuery, clinicId, loadPatients])

  useEffect(() => {
    if (!clinicId) {
      setEvents([])
      return
    }

    const run = async () => {
      const freshHeld = await loadHeldSlots(clinicId, date)
      await loadAgenda(clinicId, date, freshHeld)
    }

    run()
  }, [clinicId, date, setEvents, loadHeldSlots, loadAgenda])

  useEffect(() => {
    if (!calendarRef.current || !date) return

    if (lastCalendarDateRef.current === date) return

    const api = calendarRef.current.getApi()
    api.gotoDate(date)
    lastCalendarDateRef.current = date
  }, [date, calendarRef, lastCalendarDateRef])
}